<template lang="pug">
div
  .line-container(:style="showtitle?'padding-top:0.78rem':'padding-top:0rem'" :class="isNewType?'line-new':''")
    //- 头部推荐文字模块
    .purchase-plan-block(v-if="(!isAppVip || version === PropVersionMap.RIDE_ONE_CENT)&&!isNewType" :style="env.isEasyBikeApp?'':'padding-top:0.16rem;margin-bottom:0.16rem'")
      img.purchase-one-cent(v-if="version === PropVersionMap.RIDE_ONE_CENT" :src="oneCentRideRecommendImgOldVersion")
      .left-purchase(v-else)
        .left-purchase-line-one
          .left-purchase-line-one-img
            img(:src="cardPurchase.icon")
          .left-purchase-line-one-word {{ cardPurchase.tagSuggestion }}
        .left-purchase-line-two
          span {{splitString(cardPurchase.verbalTrick, cardPurchase.highlight)[0]}}
          span.red-word {{cardPurchase.highlight}}
          span {{splitString(cardPurchase.verbalTrick, cardPurchase.highlight)[2]}}
      .right-purchase
        img(src="https://m.hellobike.com/resource/gallery/61/OJaSQsRr6s.png?x-oss-process=image/quality,q_80")
    //- 头部菜单tab
    .ladder-tab(v-if="goodsList.length>1&&!isNewType" :style="getTabStyle()"
      :class="(buyingAdviceAB&&env.isEasyBikeApp)?'isplan':''")
      .ladder-flex
        .ladder-tab-item(v-for="(item,index) in goodsList"
          :style="`width:${100/goodsList.length}%`")
          .tab-container(@click="changeTab(true, index)"
            :class="(index===chooseIndex?'showChooseT':'showNChooseT')")
            .sp-word
              span {{VERISON_MAP[item.propVersion]}}
              img.corner-mark(v-if="VERISON_CORNER_MARK_MAP[item.propVersion]" :src="VERISON_CORNER_MARK_MAP[item.propVersion]")
            .small-word(
              v-if="VERISON_STATEMENT[item.propVersion]"
              ) {{ VERISON_STATEMENT[item.propVersion] }}
    ladderLeftTab(
      :key="chooseIndex"
      v-if="showRide&&chooseObj.groupList"
      :aggCardList="aggCardList"
      :groupList="chooseObj.groupList"
      :rideCardInfo="chooseObj.rideCardInfo||{}"
      :zeroBuyCardShow="zeroBuyCardShow"
      :expandAllPropertyAB="chooseObj.expandAllPropertyAB"
      :version="version"
      :bikeCardShowStyle="bikeCardShowStyle"
      :isNewType="isNewType"
      :anchoredVersion="anchoredVersion"
      :style="getBlockStyle()"
      @chooseCard="getChooseCard")
    .no-group-list(v-if="showRide&&!chooseObj.groupList")
      img(src="https://m.hellobike.com/resource/helloyun/08345/goPEMwHkQ9.png?x-oss-process=image/format,webp")
    .ladder-right-tab(v-show="!showRide" :style="getBlockStyle()")
      ladderBlendCouponTab(
        v-if="version === 'ladder_blend'"
        :groupList="groupList"
        :ladderPropGroupList="ladderPropGroupList"
        :ladderDetailMap="ladderDetailMap"
        :allPropList="chooseObj.allPropList"
        :newCustomer="newCustomer"
      )
      enjoyTravelV2(
      v-else
      :ladderPropGroupList="ladderPropGroupList"
      :ladderDetailMap="ladderDetailMap"
      :groupList="groupList"
      :allPropList="chooseObj.allPropList"
      :version="version"
      @openModal="openModal"
      )
  lifeGoCard(
  ref="lifeCard" :groupList="groupList"
  :ladderPropGroupList="ladderPropGroupList"
  :ladderDetailMap="ladderDetailMap"
  :newCustomer="newCustomer")
</template>
<script>
import { getNoScroll } from '@/utils';
import Picture from '@/components/picture';
import { env } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import deepCopy from '@/utils/deepCopy';
import { PropVersionMap } from '@/const/vip';
import { oneCentRideRecommendImgOldVersion } from '@/assets/imgAssets';
import lifeGoCard from './life-go-card.vue';
import lifeCardBussiness from './life-card-bussiness.vue';
import ladderLeftTab from './ladder-left-tab';
import enjoyTravelV2 from './enjoy-travel-v2.vue';
import ladderBlendCouponTab from './ladder-blend-coupon-tab';
import {
  VERISON_MAP, VERISON_WORD, VERISON_STATEMENT, VERISON_CORNER_MARK_MAP,
} from '../../consts';

export default {
  components: {
    lifeGoCard,
    Picture,
    lifeCardBussiness,
    ladderLeftTab,
    enjoyTravelV2,
    ladderBlendCouponTab,
  },
  props: {
    zeroBuyCardShow: {
      type: Boolean,
      default: false,
    },
    ladderPropGroupList: {
      type: Array,
      required: true,
    },
    groupList: {
      type: Array,
      required: true,
    },
    goodsList: {
      type: Array,
      required: true,
    },
    ladderDetailMap: {
      type: Object,
      required: true,
    },
    newCustomer: {
      type: Boolean,
      required: true,
    },
    showStyleVersion: {
      type: String,
      default: '',
    },
    showAppExpensive: {
      type: Boolean,
      required: true,
    },
    version: {
      type: String,
      required: true,
    },
    buyingAdviceAB: {
      type: Boolean,
      default: false,
    },
    cardPurchase: {
      type: Object,
      default: () => ({
        tagSuggestion: '',
        verbalTrick: '',
        highlight: '',
        icon: '',
      }),
    },
    bikeCardShowStyle: {
      type: String,
      default: '',
    },
    // isNewType：新版会员是true，旧版是false，只有旧版展示推荐模块
    isNewType: {
      type: Boolean,
      default: false,
    },
    isAppVip: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showLife: false,
      isNew: null,
      env,
      carouselOptions: {
        autoplay: true,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      chooseObj: {
        groupList: [],
      },
      showLeft: true,
      showRight: 'background-image: url(\'https://m.hellobike.com/resource/helloyun/08345/qx0mQ_tab2.png?x-oss-process=image/quality,q_80\')',
      styleVersion: 2,
      showRide: false,
      titleArr: [],
      VERISON_MAP,
      VERISON_WORD,
      VERISON_STATEMENT,
      chooseIndex: 0,
      twoTab: ['https://m.hellobike.com/resource/helloyun/08345/s1MSn_tab.png?x-oss-process=image/quality,q_80', 'https://m.hellobike.com/resource/helloyun/08345/qx0mQ_tab2.png?x-oss-process=image/quality,q_80'],
      thirdTab: ['https://m.hellobike.com/6fccf88b_left819821.png', 'https://m.hellobike.com/16cd15c7_mid11.png', 'https://m.hellobike.com/83f98943_right89112.png'],
      tabStyle: '1',
      aggList: [],
      aggCardList: [],
      anchoredVersion: null,
      goodsLists: [],
      VERISON_CORNER_MARK_MAP,
      PropVersionMap,
      oneCentRideRecommendImgOldVersion,
    };
  },
  computed: {
    firstList() {
      return this.groupList[0].coupons.slice(0, 4);
    },
    showtitle() {
      return this.showAppExpensive;
    },
  },
  watch: {
    showAppExpensive(val) {
      this.showtitle = val;
    },
    goodsList: {
      deep: true,
      immediate: true,
      async handler(val) {
        await this.checkAgg(val);
      },
    },
  },
  async created() {
    this.chooseObj = this.goodsList[this.chooseIndex];
    // if(this.chooseObj.aggCategory === 'aggCategory'){
    //   this.chooseObj = this.goodsList[0];
    // }
    this.checkAgg(this.goodsList);
    if (this.goodsList[this.chooseIndex].propVersion.includes('ride')) {
      this.showRide = true;
    } else {
      this.showRide = false;
    }
    this.$emit('ladderEasyTab', this.chooseIndex, true);
  },
  mounted() {
    // this.$refs.swiper.$el.ontouchstart = () => {
    //   this.$refs.swiper.$swiper.autoplay.stop();
    // };
    // this.$refs.swiper.$el.ontouchend = () => {
    //   this.$refs.swiper.$swiper.autoplay.start();
    // };
    UBT.moduleExpose({
      pageId: 'platform_savemoneycard_page',
      categoryId: 'platform',
      moduleId: 'platform_VIP_tab',
      contentId: 'platform_VIP_tab',
      exposureTimes: 2,
      businessInfo: {},
    });
  },
  inject: ['freeRightsVersion'],
  methods: {
    async checkAgg(val) {
      const temp = deepCopy(val);
      this.chooseObj = temp[this.chooseIndex];
      if (val[this.chooseIndex].aggCategory) {
        this.aggList = this.chooseObj.goodsList;
        this.anchoredVersion = this.chooseObj.anchoredVersion;
        if (this.aggList && this.aggList.length) {
          const tempArr = this.aggList.filter((i) => i.propVersion === this.anchoredVersion);
          if (tempArr && tempArr.length > 0) {
            // eslint-disable-next-line prefer-destructuring
            this.chooseObj = tempArr[0];
            await this.$emit('aggData', this.chooseObj);
          } else {
            // eslint-disable-next-line space-infix-ops, prefer-destructuring
            this.chooseObj= this.aggList[0];
            await this.$emit('aggData', this.chooseObj);
          }
          this.aggCardList = this.aggList.map((i) => ({
            ...i.mainPropertyDetail,
            propVersion: i.propVersion,
          }));
        }
      } else {
        this.aggList = [];
        this.aggCardList = [];
      }
    },
    showFlag(val) {
      return val.includes('ride');
    },
    flagWord(val) {
      if (val.includes('ebike')) {
        return '助力车';
      }
      return '单车';
    },
    getTabStyle() {
      const tempList = this.goodsList.filter((i) => i.propVersion.includes('_app')); // 特权版
      if (this.goodsList.length < 2) {
        if (this.goodsList[0].propVersion === 'ladder') {
          this.showLeft = false;
        } else {
          this.showLeft = true;
        }
        if (this.showLeft) {
          return !env.isEasyBikeApp && tempList.length === 0 ? 'display:none; margin-top: -0.2rem;' : 'display:none;';
        }
        return !env.isEasyBikeApp && tempList.length === 0
          ? 'display:none; background-image: url(\'https://m.hellobike.com/resource/helloyun/08345/BpLUU_tab2.png?x-oss-process=image/format,webp\'); margin-top: -0.2rem;'
          : 'display:none; background-image: url(\'https://m.hellobike.com/resource/helloyun/08345/BpLUU_tab2.png?x-oss-process=image/format,webp\');';
      }
      if (this.goodsList.length === 2) {
        return !env.isEasyBikeApp && tempList.length === 0
          ? `background-image: url(${this.twoTab[this.chooseIndex]}); margin-top: -0.2rem;`
          : `background-image: url(${this.twoTab[this.chooseIndex]});`;
      }
      // 3个tab
      return !env.isEasyBikeApp && tempList.length === 0
        ? `background-image: url(${this.thirdTab[this.chooseIndex]}); margin-top: -0.2rem;`
        : `background-image: url(${this.thirdTab[this.chooseIndex]});`;
    },
    getBlockStyle() {
      if (this.freeRightsVersion()) {
        return '';
      }
      if (this.isNewType) {
        return 'margin-top: 0.50rem';
      }
      if (this.goodsList.length < 2 && !this.showLeft) {
        return 'margin-top: 0.35rem';
      } if (this.goodsList.length < 2 && this.showLeft) {
        return 'margin-top: -0.35rem';
      }
      return '';
    },
    openModal() {
      getNoScroll(true);
      this.$refs.lifeCard.open();
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_copuon_card',
        categoryId: 'platform',
        businessInfo: {},
      });
    },
    async changeTab(val, index) {
      this.chooseIndex = index;
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_VIP_tab',
        categoryId: 'platform',
        businessInfo: {},
      });
      if (this.goodsList[this.chooseIndex].propVersion.includes('ride')) {
        this.showRide = true;
      } else {
        this.showRide = false;
      }
      await this.checkAgg(this.goodsList);
      this.showLeft = val;
      this.$emit('ladderEasyTab', index);
    },
    splitString(fullStr, searchStr) {
      // 找到搜索字符串在完整字符串中的起始位置
      const startIndex = fullStr.indexOf(searchStr);
      // 如果搜索字符串不存在于完整字符串中，返回原字符串
      if (startIndex === -1) {
        return [fullStr];
      }
      // 分割字符串
      const part1 = `${fullStr.substring(0, startIndex)}`;
      const part2 = searchStr;
      const part3 = `${fullStr.substring(startIndex + searchStr.length)}`;
      return [part1, part2, part3];
    },
    getChooseCard(val) {
      this.chooseObj = this.aggList[val];
      this.$emit('aggData', this.chooseObj);
      this.$emit('chooseIndex', val);
    },
  },
};
</script>

<style lang="less" scoped>
.showLeft {
  font-weight: 600;
  font-size: 0.18rem;
}

.showRight {
  font-weight: 400;
  margin-top: 0.02rem;
  color: #441d06;
}

.showNChooseT {
  font-weight: 400;
  margin-top: 0.02rem;
  color: #441d06;
}

.line-container {
  border-radius: 0.12rem;
  position: relative;
  padding-top: -0.1rem;
  // background: linear-gradient(180deg ,#fcfdfd 10%, #f5f6f8 100%);

  .first-top-block {
    padding-left: 2rem;
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 0.192rem;
    color: #000;
    line-height: 20px;
    font-weight: 500;

    .red-font {
      font-family: DINAlternate-Bold, sans-serif;
      font-size: 0.26rem;
      color: #f54311;
      font-weight: 700;
    }

    .jump-icon {
      margin-left: 0.02rem;
      width: 0.08rem;
      height: 0.1rem;
    }
  }

  .purchase-plan-block {
    height: 0.95rem;
    background: #fce488;
    display: flex;
    justify-content: space-between;

    .purchase-one-cent {
      height: 0.6rem;
      width: 2.77rem;
      margin-left: 0.12rem;
      margin-top: -0.05rem;
      margin-bottom: 0.02rem;
    }

    .left-purchase {
      background-image: url(https://m.hellobike.com/resource/gallery/61/xNqtgF9L_Group%20612-2.png?x-oss-process=image/quality,q_80);
      background-size: 100% 100%;
      height: 0.6rem;
      width: 2.77rem;
      margin-left: 0.12rem;
      margin-top: -0.05rem;
      margin-bottom: 0.02rem;

      .left-purchase-line-one {
        display: flex;
        padding-top: 0.05rem;
        padding-left: 0.13rem;
        margin-bottom: -0.06rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-size: 0.16rem;
        font-weight: 400;
        color: #b34a00;

        .left-purchase-line-one-img {
          img {
            width: 0.25rem;
            height: 0.28rem;
          }
        }

        .left-purchase-line-one-word {
          line-height: 0.32rem;
        }
      }

      .left-purchase-line-two {
        padding-left: 0.16rem;
        font-family: PingFang SC, sans-serif;
        font-size: 0.12rem;
        font-weight: 400;
        color: #b34a00;

        .red-word {
          color: #f72626;
          font-weight: 500;
        }
      }
    }

    .right-purchase {
      overflow: hidden;

      img {
        width: 0.94rem;
        height: 0.9rem;
      }
    }
  }

  .no-group-list {
    background: #fbfdff;
    height: 70vh;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 1.76rem;
      height: 0.18rem;
    }
  }

  .ladder-tab {
    margin-top: -0.2rem;
    height: 0.47rem;
    background-image: url('https://m.hellobike.com/resource/helloyun/08345/s1MSn_tab.png?x-oss-process=image/quality,q_80');
    background-size: 100% 100%;
    font-size: 0.16rem;
    z-index: 2;
    position: relative;

    .ladder-flex {
      display: flex;
      text-align: center;
      line-height: 0.47rem;

      .ladder-tab-item {
        width: 100%;
        text-align: center;
        line-height: 0.47rem;

        .ladder-lab-block {
          display: flex;
          justify-content: center;

          .business-flag {
            font-family: PingFangSC-Medium, PingFang SC, sans-serif;
            margin-top: 0.14rem;
            margin-left: 0.03rem;
            border-radius: 0.08rem 0.01rem 0.08rem 0.01rem;
            font-size: 0.11rem;
            color: #fff;
            height: 0.16rem;
            line-height: 0.16rem;
            padding: 0 0.04rem;
            background: linear-gradient(90deg, #ffc56e -18.33%, #ff9f46 75%);
          }
        }

        .tab-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 0.47rem;

          .sp-word {
            font-size: 0.14rem;
            font-weight: 500;
            text-align: center;
            height: 0.22rem;
            line-height: 0.22rem;
            color: #441d06;
            display: flex;
            align-items: center;

            .corner-mark {
              height: 0.16rem;
              object-fit: contain;
              margin-left: 0.02rem;
            }
          }

          .small-word {
            font-family: PingFang SC, sans-serif;
            font-size: 0.1rem;
            font-weight: 400;
            text-align: center;
            line-height: 0.15rem;
            color: #909090;
          }

          &.showChooseT {
            font-family: PingFang SC, sans-serif;
            font-weight: 600;

            .sp-word {
              font-size: 0.16rem;
              font-weight: 800;
              color: #000;
            }

            .small-word {
              color: #242729;
            }
          }
        }
      }
    }

    .ladder-left {
      text-align: center;
      width: 100%;
      height: 100%;
      line-height: 0.47rem;

      .ladder-title {
        width: 100%;
        height: 100%;
      }
    }

    .ladder-right {
      width: 100%;
      line-height: 0.47rem;
      text-align: center;
    }
  }

  .isplan {
    margin-top: -0.2rem;
  }

  .ladder-right-tab {
    background: #fff;
    border-radius: 0.16rem;
    margin: 0.16rem 0.12rem 0.08rem 0.12rem;
    padding: 0.15rem 0;
    border: 0.005rem solid #ebeef0;
  }

  .middle-word {
    margin-top: 0.18rem;
    margin-bottom: 0.12rem;
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 0.14rem;
    color: #242729;
    font-weight: 400;
    text-align: left;
    padding-left: 0.2rem;
  }

  .two-line-block {
    line-height: 0.2rem;
    font-size: 0.14rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #242729;

    &-carousel {
      margin-top: 0.12rem;
      overflow: scroll;

      .swiper-pagination {
        bottom: 0.09rem;

        /deep/ .swiper-pagination-bullet {
          height: 0.03rem;
          width: 0.12rem;
          border-radius: 0.05rem;
          margin: 0 0.02rem;
        }
      }

      .life-card-second-bussiness-item {
        .card {
          height: 1.57rem;
        }
      }
    }
  }
}

.line-new {
  border-radius: 0;
  // background: #f2f6f8;
}

.free-rights-version {
  .line-new {
    background: unset;
  }
}
</style>
